<template>
  <div>
    <div class="page-header-wrapper padding-rb">
      <PageHeader :title="`${title} Customer List`">
        <el-input
          prefix-icon="el-icon-search"
          placeholder="Search"
          v-model="searchVal"
          v-debounce="onSearch"
          clearable
          @clear="onSearch"
        />
        <import-button
          v-role="[1]"
          :action="`/customer/importRelation/${roleType}`"
          @success="getTableData()"
        />
        <el-dropdown v-role="[1]" trigger="click" @command="handleCommand">
          <el-button type="primary">
            Export <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu class="export-dropdown" slot="dropdown">
            <el-dropdown-item
              icon="el-icon-download"
              command="leader"
              :disabled="disableExportLeader"
            >
              {{ title }} User
            </el-dropdown-item>
            <el-dropdown-item
              icon="el-icon-download"
              command="customer"
              :disabled="disableExportSEUser"
            >
              Customer User
            </el-dropdown-item>
            <el-dropdown-item icon="el-icon-download" command="template">
              Import Template
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </PageHeader>
    </div>
    <div class="table-wrapper">
      <el-table
        ref="table"
        :data="tableData"
        v-loading="tableLoading"
        element-loading-text="Loading..."
        @sort-change="onSortChange"
      >
        <el-table-column
          prop="SEName"
          label="Customer Name"
          min-width="160"
          sortable="custom"
        />
        <el-table-column
          prop="City"
          label="City"
          min-width="80"
          sortable="custom"
        />
        <el-table-column
          prop="hospital"
          label="Hospital / Institution"
          min-width="180"
          sortable="custom"
        />
        <el-table-column
          prop="Department"
          label="Department"
          min-width="140"
          sortable="custom"
        />
        <el-table-column
          prop="MLName"
          :label="title"
          min-width="100"
          sortable="custom"
        >
          <template slot-scope="scope">
            <span style="margin-right: 10px">{{ scope.row.MLName }}</span>
            <el-popover
              v-if="scope.row.LeaderTotal > 0"
              popper-class="leader-list-popover"
              trigger="hover"
              placement="bottom-end"
              @show="onLeaderShow(scope.$index, scope.row)"
            >
              <div
                class="leader-list"
                :class="{ loading: scope.row.loading }"
                v-loading="scope.row.loading"
                element-loading-text="Loading..."
              >
                <div class="leader-header">
                  <span class="name"
                    ><strong>{{ title }} Name</strong></span
                  >
                  <span class="team"><strong>Team</strong></span>
                </div>
                <div
                  class="leader-item"
                  v-for="(item, i) in scope.row.leaders"
                  :key="i"
                >
                  <span class="name">{{ item.LeaderName }}</span>
                  <span class="team">{{ item.TeamName }}</span>
                </div>
              </div>
              <el-tag
                class="crp-more"
                slot="reference"
                type="warning"
                effect="dark"
              >
                {{ scope.row.LeaderTotal }}
                <i class="el-icon-arrow-down"></i>
              </el-tag>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          prop="Certified"
          width="110"
          label="Certified"
          sortable="custom"
        >
          <template slot-scope="{ row }" v-if="!row.isChildren">
            <el-tag :type="tagTypeParser(row.Active)" effect="dark">
              {{ tagLabelParser(row.Active) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="Operation"
          width="100"
          prop="StatusDesc"
          align="center"
        >
          <template
            slot-scope="{ row }"
            prop="StatusDesc"
            v-if="!row.isChildren"
          >
            <el-button type="text" icon="el-icon-edit" @click="handleEdit(row)">
              Edit
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :pager-count="pagerCount"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        />
      </div>
    </div>
    <EditCustomerDialog
      :visible.sync="editSEDialogVisible"
      :role-type="roleType"
      :title="title"
      :data.sync="rowData"
      @success="getTableData"
    />
  </div>
</template>

<script>
import ImportButton from "./import-button";
import EditCustomerDialog from "./edit-customer-dialog";
import downloadjs from "downloadjs";

export default {
  name: "CustomerList",
  components: { EditCustomerDialog, ImportButton },
  props: ["roleType", "title"],
  data() {
    return {
      tableLoading: true,
      searchVal: "",
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      orderBy: "CreatedOn",
      orderType: "descending",
      editSEDialogVisible: false,
      rowData: null,
      disableExportLeader: false,
      disableExportSEUser: false,
    };
  },
  computed: {
    role() {
      return this.$store.state.role;
    },
    pagerCount() {
      let clientWidth = document.body.clientWidth;
      return clientWidth <= 1024 ? 5 : 7;
    },
  },
  created() {
    this.getTableData();
    this.bus.$on("refresh", ({ name }) => {
      if (this.$parent.$options.name === name) {
        this.getTableData();
      }
    });
  },
  methods: {
    tagTypeParser(flag) {
      return flag ? "success" : "danger";
    },
    tagLabelParser(flag) {
      return flag ? "Yes" : "No";
    },
    onSearch() {
      this.currentPage = 1;
      this.getTableData();
    },
    handleCommand(command) {
      switch (command) {
        case "leader":
          this.exportLeaderList();
          break;
        case "customer":
          this.exportCustomerList();
          break;
        case "template":
          this.downloadTemplate();
          break;
      }
    },
    downloadTemplate() {
      this.axios
        .get("/template/SEUserMapImportTemplate.xlsx", {
          baseURL: "/",
          responseType: "blob",
        })
        .then((data) => {
          downloadjs(
            data,
            `${this.title}_Import_Template.xlsx`,
            "application/vnd.ms-excel"
          );
          this.$message.success(
            `${this.title} import template download successful!`
          );
        });
    },
    exportLeaderList() {
      this.disableExportLeader = true;
      const msg = this.$message({
        message: `${this.title} is exporting...`,
        duration: 0,
      });
      this.axios
        .get(`/user/export/${this.roleType}`, {
          responseType: "blob",
        })
        .then(({ data }) => {
          this.disableExportLeader = false;
          downloadjs(data.file, data.fileName, "application/vnd.ms-excel");
          msg.type = "success";
          msg.message = `Export ${this.title} User successful!`;
          setTimeout(() => {
            msg.close();
          }, 3000);
        })
        .catch(() => {
          this.disableExportLeader = false;
          msg.type = "error";
          msg.message = `Export ${this.title} User failure!`;
          setTimeout(() => {
            msg.close();
          }, 3000);
        });
    },
    exportCustomerList() {
      this.disableExportSEUser = true;
      const msg = this.$message({
        message: "Customer User is exporting...",
        duration: 0,
      });
      this.axios
        .get("/se/export", {
          responseType: "blob",
        })
        .then(({ data }) => {
          this.disableExportSEUser = false;
          downloadjs(data.file, data.fileName, "application/vnd.ms-excel");
          msg.type = "success";
          msg.message = "Export Customer User successful!";
          setTimeout(() => {
            msg.close();
          }, 3000);
        })
        .catch(() => {
          this.disableExportSEUser = false;
          msg.type = "error";
          msg.message = "Export Customer User failure!";
          setTimeout(() => {
            msg.close();
          }, 3000);
        });
    },
    onLeaderShow(index, row) {
      const { SEID } = row;
      this.$set(this.tableData[index], "loading", true);
      this.axios
        .get(`/customer/getLeaderList/${this.roleType}/${SEID}`)
        .then(({ code, data }) => {
          if (code === 200) {
            this.$set(this.tableData[index], "loading", false);
            this.$set(this.tableData[index], "leaders", data);
          }
        });
    },
    getTableData() {
      this.tableLoading = true;
      let params = {
        pageSize: this.pageSize,
        page: this.currentPage,
        orderBy: this.orderBy,
        orderType: this.orderType,
        key: this.searchVal,
      };
      this.axios
        .get(`/customer/getRelationList/${this.roleType}`, {
          params: params,
        })
        .then(({ code, data, msg }) => {
          if (200 === code) {
            this.tableData = data.data.map((item) => {
              return {
                ...item,
                loading: false,
                leaders: [],
              };
            });
            this.total = data.total;
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getTableData();
    },
    onSuccess(resetPage = false) {
      this.orderBy = resetPage ? "CreatedOn" : this.orderBy;
      this.currentPage = resetPage ? 1 : this.currentPage;
      this.multipleSelection = [];
      this.getTableData();
    },
    onSortChange(column) {
      this.orderBy = column.prop;
      this.orderType = column.order;
      this.getTableData();
    },
    handleEdit(row) {
      this.rowData = row;
      this.editSEDialogVisible = true;
    },
  },
};
</script>
<style lang="scss">
.leader-list-popover {
  padding: 10px 15px;
  min-width: 280px;

  .leader-list {
    &.loading {
      min-height: 80px;

      .el-loading-spinner {
        margin-top: -35px;
      }
    }

    .leader-header,
    .leader-item {
      display: flex;
      justify-content: space-between;

      span {
        &.name {
          min-width: 60px;
        }

        &.team {
          min-width: 100px;
        }
      }

      line-height: 30px;
    }
  }
}

.export-dropdown {
  a {
    display: block;
  }

  a,
  i,
  a i:hover {
    color: inherit !important;
  }
}
</style>

<style lang="scss" scoped>
::v-deep {
  .el-table__row--level-1:not(:last-child) td {
    background-color: #f5f7fa;
  }
}

.crp-more {
  cursor: pointer;
}

.el-dropdown {
  margin-left: 10px;
  display: flex;
}

.pagination-wrap {
  display: flex;
  justify-content: flex-end;

  .actions {
    display: flex;
  }

  .transfer-actions,
  .el-button {
    margin-left: 10px;
  }
}
</style>
